import iFrameResize from 'iframe-resizer/js/iframeResizer'

import Sortable from './Sortable.js'
import ConnectedDroppable from './ConnectedDroppable.js'
import Autofocus from './Autofocus.js'

export default (Vue) => {
  Vue.directive('sortable', Sortable)
  Vue.directive('connectedDroppable', ConnectedDroppable)
  Vue.directive('autofocus', Autofocus)
  Vue.directive('resize', {
    bind: function (el, { value = {} }) {
      el.addEventListener('load', () => iFrameResize(value, el))
    }
  })
}



// WEBPACK FOOTER //
// ./src/directives/index.js